import { observer } from 'mobx-react-lite';

import { Select } from '@components/select';

export const CountryCode = observer(({ onChange, defaultValue, label, inModal }) => {
  const options = [
    { value: 'AD +376', label: 'AD +376' },
    { value: 'AE +971', label: 'AE +971' },
    { value: 'AF +93', label: 'AF +93' },
    { value: 'AG +1268', label: 'AG +1268' },
    { value: 'AI +1264', label: 'AI +1264' },
    { value: 'AL +355', label: 'AL +355' },
    { value: 'AM +374', label: 'AM +374' },
    { value: 'AN +599', label: 'AN +599' },
    { value: 'AO +244', label: 'AO +244' },
    { value: 'AQ +672', label: 'AQ +672' },
    { value: 'AR +54', label: 'AR +54' },
    { value: 'AS +1684', label: 'AS +1684' },
    { value: 'AT +43', label: 'AT +43' },
    { value: 'AU +61', label: 'AU +61' },
    { value: 'AW +297', label: 'AW +297' },
    { value: 'AZ +994', label: 'AZ +994' },
    { value: 'BA +387', label: 'BA +387' },
    { value: 'BB +1246', label: 'BB +1246' },
    { value: 'BD +880', label: 'BD +880' },
    { value: 'BE +32', label: 'BE +32' },
    { value: 'BF +226', label: 'BF +226' },
    { value: 'BG +359', label: 'BG +359' },
    { value: 'BH +973', label: 'BH +973' },
    { value: 'BI +257', label: 'BI +257' },
    { value: 'BJ +229', label: 'BJ +229' },
    { value: 'BL +590', label: 'BL +590' },
    { value: 'BM +1441', label: 'BM +1441' },
    { value: 'BN +673', label: 'BN +673' },
    { value: 'BO +591', label: 'BO +591' },
    { value: 'BR +55', label: 'BR +55' },
    { value: 'BS +1242', label: 'BS +1242' },
    { value: 'BT +975', label: 'BT +975' },
    { value: 'BW +267', label: 'BW +267' },
    { value: 'BY +375', label: 'BY +375' },
    { value: 'BZ +501', label: 'BZ +501' },
    { value: 'CA +1', label: 'CA +1' },
    { value: 'CC +61', label: 'CC +61' },
    { value: 'CD +243', label: 'CD +243' },
    { value: 'CF +236', label: 'CF +236' },
    { value: 'CG +242', label: 'CG +242' },
    { value: 'CH +41', label: 'CH +41' },
    { value: 'CI +225', label: 'CI +225' },
    { value: 'CK +682', label: 'CK +682' },
    { value: 'CL +56', label: 'CL +56' },
    { value: 'CM +237', label: 'CM +237' },
    { value: 'CN +86', label: 'CN +86' },
    { value: 'CO +57', label: 'CO +57' },
    { value: 'CR +506', label: 'CR +506' },
    { value: 'CU +53', label: 'CU +53' },
    { value: 'CV +238', label: 'CV +238' },
    { value: 'CW +599', label: 'CW +599' },
    { value: 'CX +61', label: 'CX +61' },
    { value: 'CY +357', label: 'CY +357' },
    { value: 'CZ +420', label: 'CZ +420' },
    { value: 'DE +49', label: 'DE +49' },
    { value: 'DJ +253', label: 'DJ +253' },
    { value: 'DK +45', label: 'DK +45' },
    { value: 'DM +1767', label: 'DM +1767' },
    { value: 'DO +1809', label: 'DO +1809' },
    { value: 'DO +1829', label: 'DO +1829' },
    { value: 'DO +1849', label: 'DO +1849' },
    { value: 'DZ +213', label: 'DZ +213' },
    { value: 'EC +593', label: 'EC +593' },
    { value: 'EE +372', label: 'EE +372' },
    { value: 'EG +20', label: 'EG +20' },
    { value: 'EH +212', label: 'EH +212' },
    { value: 'ER +291', label: 'ER +291' },
    { value: 'ES +34', label: 'ES +34' },
    { value: 'ET +251', label: 'ET +251' },
    { value: 'FI +358', label: 'FI +358' },
    { value: 'FJ +679', label: 'FJ +679' },
    { value: 'FK +500', label: 'FK +500' },
    { value: 'FM +691', label: 'FM +691' },
    { value: 'FO +298', label: 'FO +298' },
    { value: 'FR +33', label: 'FR +33' },
    { value: 'GA +241', label: 'GA +241' },
    { value: 'GB +44', label: 'GB +44' },
    { value: 'GD +1473', label: 'GD +1473' },
    { value: 'GE +995', label: 'GE +995' },
    { value: 'GG +441481', label: 'GG +441481' },
    { value: 'GH +233', label: 'GH +233' },
    { value: 'GI +350', label: 'GI +350' },
    { value: 'GL +299', label: 'GL +299' },
    { value: 'GM +220', label: 'GM +220' },
    { value: 'GN +224', label: 'GN +224' },
    { value: 'GQ +240', label: 'GQ +240' },
    { value: 'GR +30', label: 'GR +30' },
    { value: 'GT +502', label: 'GT +502' },
    { value: 'GU +1671', label: 'GU +1671' },
    { value: 'GW +245', label: 'GW +245' },
    { value: 'GY +592', label: 'GY +592' },
    { value: 'HK +852', label: 'HK +852' },
    { value: 'HN +504', label: 'HN +504' },
    { value: 'HR +385', label: 'HR +385' },
    { value: 'HT +509', label: 'HT +509' },
    { value: 'HU +36', label: 'HU +36' },
    { value: 'ID +62', label: 'ID +62' },
    { value: 'IE +353', label: 'IE +353' },
    { value: 'IL +972', label: 'IL +972' },
    { value: 'IM +441624', label: 'IM +441624' },
    { value: 'IN +91', label: 'IN +91' },
    { value: 'IO +246', label: 'IO +246' },
    { value: 'IQ +964', label: 'IQ +964' },
    { value: 'IR +98', label: 'IR +98' },
    { value: 'IS +354', label: 'IS +354' },
    { value: 'IT +39', label: 'IT +39' },
    { value: 'JE +441534', label: 'JE +441534' },
    { value: 'JM +1876', label: 'JM +1876' },
    { value: 'JO +962', label: 'JO +962' },
    { value: 'JP +81', label: 'JP +81' },
    { value: 'KE +254', label: 'KE +254' },
    { value: 'KG +996', label: 'KG +996' },
    { value: 'KH +855', label: 'KH +855' },
    { value: 'KI +686', label: 'KI +686' },
    { value: 'KM +269', label: 'KM +269' },
    { value: 'KN +1869', label: 'KN +1869' },
    { value: 'KP +850', label: 'KP +850' },
    { value: 'KR +82', label: 'KR +82' },
    { value: 'KW +965', label: 'KW +965' },
    { value: 'KY +1345', label: 'KY +1345' },
    { value: 'KZ +7', label: 'KZ +7' },
    { value: 'LA +856', label: 'LA +856' },
    { value: 'LB +961', label: 'LB +961' },
    { value: 'LC +1758', label: 'LC +1758' },
    { value: 'LI +423', label: 'LI +423' },
    { value: 'LK +94', label: 'LK +94' },
    { value: 'LR +231', label: 'LR +231' },
    { value: 'LS +266', label: 'LS +266' },
    { value: 'LT +370', label: 'LT +370' },
    { value: 'LU +352', label: 'LU +352' },
    { value: 'LV +371', label: 'LV +371' },
    { value: 'LY +218', label: 'LY +218' },
    { value: 'MA +212', label: 'MA +212' },
    { value: 'MC +377', label: 'MC +377' },
    { value: 'MD +373', label: 'MD +373' },
    { value: 'ME +382', label: 'ME +382' },
    { value: 'MF +590', label: 'MF +590' },
    { value: 'MG +261', label: 'MG +261' },
    { value: 'MH +692', label: 'MH +692' },
    { value: 'MK +389', label: 'MK +389' },
    { value: 'ML +223', label: 'ML +223' },
    { value: 'MM +95', label: 'MM +95' },
    { value: 'MN +976', label: 'MN +976' },
    { value: 'MO +853', label: 'MO +853' },
    { value: 'MP +1670', label: 'MP +1670' },
    { value: 'MR +222', label: 'MR +222' },
    { value: 'MS +1664', label: 'MS +1664' },
    { value: 'MT +356', label: 'MT +356' },
    { value: 'MU +230', label: 'MU +230' },
    { value: 'MV +960', label: 'MV +960' },
    { value: 'MW +265', label: 'MW +265' },
    { value: 'MX +52', label: 'MX +52' },
    { value: 'MY +60', label: 'MY +60' },
    { value: 'MZ +258', label: 'MZ +258' },
    { value: 'NA +264', label: 'NA +264' },
    { value: 'NC +687', label: 'NC +687' },
    { value: 'NE +227', label: 'NE +227' },
    { value: 'NG +234', label: 'NG +234' },
    { value: 'NI +505', label: 'NI +505' },
    { value: 'NL +31', label: 'NL +31' },
    { value: 'NO +47', label: 'NO +47' },
    { value: 'NP +977', label: 'NP +977' },
    { value: 'NR +674', label: 'NR +674' },
    { value: 'NU +683', label: 'NU +683' },
    { value: 'NZ +64', label: 'NZ +64' },
    { value: 'OM +968', label: 'OM +968' },
    { value: 'PA +507', label: 'PA +507' },
    { value: 'PE +51', label: 'PE +51' },
    { value: 'PF +689', label: 'PF +689' },
    { value: 'PG +675', label: 'PG +675' },
    { value: 'PH +63', label: 'PH +63' },
    { value: 'PK +92', label: 'PK +92' },
    { value: 'PL +48', label: 'PL +48' },
    { value: 'PM +508', label: 'PM +508' },
    { value: 'PN +64', label: 'PN +64' },
    { value: 'PR +1787', label: 'PR +1787' },
    { value: 'PR +1939', label: 'PR +1939' },
    { value: 'PS +970', label: 'PS +970' },
    { value: 'PT +351', label: 'PT +351' },
    { value: 'PW +680', label: 'PW +680' },
    { value: 'PY +595', label: 'PY +595' },
    { value: 'QA +974', label: 'QA +974' },
    { value: 'RE +262', label: 'RE +262' },
    { value: 'RO +40', label: 'RO +40' },
    { value: 'RS +381', label: 'RS +381' },
    { value: 'RU +7', label: 'RU +7' },
    { value: 'RW +250', label: 'RW +250' },
    { value: 'SA +966', label: 'SA +966' },
    { value: 'SB +677', label: 'SB +677' },
    { value: 'SC +248', label: 'SC +248' },
    { value: 'SD +249', label: 'SD +249' },
    { value: 'SE +46', label: 'SE +46' },
    { value: 'SG +65', label: 'SG +65' },
    { value: 'SH +290', label: 'SH +290' },
    { value: 'SI +386', label: 'SI +386' },
    { value: 'SJ +47', label: 'SJ +47' },
    { value: 'SK +421', label: 'SK +421' },
    { value: 'SL +232', label: 'SL +232' },
    { value: 'SM +378', label: 'SM +378' },
    { value: 'SN +221', label: 'SN +221' },
    { value: 'SO +252', label: 'SO +252' },
    { value: 'SR +597', label: 'SR +597' },
    { value: 'SS +211', label: 'SS +211' },
    { value: 'ST +239', label: 'ST +239' },
    { value: 'SV +503', label: 'SV +503' },
    { value: 'SX +1721', label: 'SX +1721' },
    { value: 'SY +963', label: 'SY +963' },
    { value: 'SZ +268', label: 'SZ +268' },
    { value: 'TC +1649', label: 'TC +1649' },
    { value: 'TD +235', label: 'TD +235' },
    { value: 'TG +228', label: 'TG +228' },
    { value: 'TH +66', label: 'TH +66' },
    { value: 'TJ +992', label: 'TJ +992' },
    { value: 'TK +690', label: 'TK +690' },
    { value: 'TL +670', label: 'TL +670' },
    { value: 'TM +993', label: 'TM +993' },
    { value: 'TN +216', label: 'TN +216' },
    { value: 'TO +676', label: 'TO +676' },
    { value: 'TR +90', label: 'TR +90' },
    { value: 'TT +1868', label: 'TT +1868' },
    { value: 'TV +688', label: 'TV +688' },
    { value: 'TW +886', label: 'TW +886' },
    { value: 'TZ +255', label: 'TZ +255' },
    { value: 'UA +380', label: 'UA +380' },
    { value: 'UG +256', label: 'UG +256' },
    { value: 'US +1', label: 'US +1' },
    { value: 'UY +598', label: 'UY +598' },
    { value: 'UZ +998', label: 'UZ +998' },
    { value: 'VA +379', label: 'VA +379' },
    { value: 'VC +1784', label: 'VC +1784' },
    { value: 'VE +58', label: 'VE +58' },
    { value: 'VG +1284', label: 'VG +1284' },
    { value: 'VI +1340', label: 'VI +1340' },
    { value: 'VN +84', label: 'VN +84' },
    { value: 'VU +678', label: 'VU +678' },
    { value: 'WF +681', label: 'WF +681' },
    { value: 'WS +685', label: 'WS +685' },
    { value: 'XK +383', label: 'XK +383' },
    { value: 'YE +967', label: 'YE +967' },
    { value: 'YT +262', label: 'YT +262' },
    { value: 'ZA +27', label: 'ZA +27' },
    { value: 'ZM +260', label: 'ZM +260' },
    { value: 'ZW +263', label: 'ZW +263' },
  ];
  return (
    <Select
      label={label}
      options={options}
      onChange={onChange}
      isClearable={false}
      defaultValue={defaultValue || 'IS +354'}
    />
  );
});
